<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Devameden Servisler</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/liste/cihaz"><button type="submit" class="btn submit bg-dark text-light">Yeni Servis</button>
          </router-link>
       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">

        <div class="row mt-2 mb-2 mr-2">
          <!-- <div class="col-lg-9 col-12">
            <button class="btn btn-outline-primary mr-2" @click="filter('All')">Tümü</button>
            <button class="btn btn-outline-secondary mr-2" v-for="(key,value) in this.$helper.groupByAdet(posts,'bolge')"
            :key="value" @click="filter(value)">{{value}}</button>
          </div> -->
                                    <div class="col-9 text-right pl-0">
        <div class="row ml-3">
          <div class="col-4"><input class="form-control" type="date" v-model="d1"></div>
          <div class="col-4"><input class="form-control" type="date" v-model="d2"></div>
          <div class="col-4">
            <button @click="getPostsAsync('kayit',true)" class="btn btn-danger d-block">Filtrele</button>
          </div>
        </div>
      </div>
          <div class="col-lg-3 col-12 text-right">
              <input class="form-control" placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
          </div>
        </div>
     <div class="row">
          <div class="col-12">
         <div class="block margin-bottom-sm">
            <div class="table-responsive"> 
               <table id="tablo" class="table table-striped">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Bölge</th>
                      <th>Müşteri</th>
                      <th>Ekip</th>
                      <th>Tarih</th>
                      <th>Model</th>
                      <th>Barkod</th>
                      <th>S.Nedeni</th>
                      <th>Süre</th>
                      <th>Detay</th>
                    </tr>
                  </thead>
                  <tbody>
                   <tr v-for="post in filteredItems(posts,'bolge')" :key="post.sid">
                    <td>{{post.no}}</td>
                    <td class="dashtext-2">{{post.bolge}}</td>
                    <td>{{post.cari}}</td>
                    <td>{{post.ekipName}}</td>
                    <td class="text-info">{{$helper.trtgoster(post.ptarih)}}</td>
                    <td>{{post.altgrup}}</td>
                    <td>{{post.barkod}}</td>
                    <td class="dashtext-3">{{post.sn}}</td>
                    <td class="text-info">{{$helper.gunhesapla(post.ptarih)}} Gün</td>
                    <td v-if="$helper.sayfayetki(592766)">
                      <router-link :to="`/detay/servis/${post.fid * 8848+'bn'+post.said*8847+'sd'+post.bid*8846+'bn'+post.sid*8589+'bna3A15899hq34888egz301'}`">Detay</router-link>
                    </td>
                   </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p class="text-center">{{progres.mesaj}} </p>
          </div>
        </div>
        <div v-if="!progres.inprogres" class="row">
          <div class="col-lg-6 col-12">
            <div class="row">
              <div class="col-12">
               <div class="pie-chart chart block">
                 <div class="title"><strong>Bölgelere göre</strong>
                 <small> (Veriler Anlık Değişebilir)</small>
                 </div>
<apexchart type="pie" width="100%" :options="sn.chartOptions" :series="sn.series"></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Servis Tipine</strong>
                   <small> (Veriler Anlık Değişebilir)</small>
                  </div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="st.chartOptions" :series="st.series"></apexchart>
                  </div>
                </div>
          </div>
        </div>        
      </div>
    </section>
    <div v-if="progres.inprogres">
      <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
      <div id="spinner-back" class="show"></div>
    </div>  
  </div>
</template>

<script>

export default {
   created() {
    this.progres.inprogres = true

    this.yetki();
  },
  data () {
    return {
      sd :3, //this.$route.params.id/8589,
      posts : [],
      error :[],
      currentTag: 'All',
      donem : this.$request.donem(),
      durum:{},
      sn : {},
      st:{},
      bolge:[],
      ayar:this.$request.ayar(),
      d1:this.$request.setFiltre().aylik.t1,
      d2:this.$request.setFiltre().aylik.t2,
      
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      }              
    }
  },
    methods : {

      yetki:function(){
          let baslat = false;
          let table ='';
            if (this.ayar.ya==='sid'){
                table = 'servis'
                baslat = true
                this.getPostsAsync(table,baslat)
            }
            else{
              table = 'kayit'
              baslat=true
              this.getPostsAsync(table,baslat)
            }

      },

        getPostsAsync (table,baslat){
          if (baslat){
              this.$request.get("servis/sd/"+this.ayar.ya+"/"+this.ayar.kid+'/'+this.sd+'/'+table+'/'+this.d1+'/'+this.d2+'/'+this.ayar.p)
          .then(res => {
            console.log(res)

            if (res.results.length>0) {
                this.posts =res.results.sort((t1,t2) => t2.sid < t1.sid ? -1 : 1)
                  this.st = this.$helper.piechart(this.$helper.groupByAdet(res.results,'st'))
                  this.sn = this.$helper.piechart(this.$helper.groupByAdet(res.results,'bolge'))
                  this.progres.inprogres = false
                  this.progres.mesaj = "" 
            }
            else {
                  this.progres.inprogres = false;
                  this.progres.mesaj = "Kayıt Bulunamadı"
                  this.posts = []
                }
            }).catch(err => {
              this.error.push(err)
              this.progres.inprogres = false

            })
          }
        },
        filter: function(tag) {
          this.currentTag = tag;
        },
        filteredItems: function(array,field) {
          var filter = this.currentTag;
          if (filter == 'All' ){
              return array
          }
          else{
                return array.filter(function(item) {
                return item[field].indexOf(filter) !== -1;
            });
          }
          },
     }
   }
</script>
<style scoped>
@media
	  only screen 
    and (max-width: 760px), (min-device-width: 768px) 
    and (max-device-width: 1024px)  {
		table, thead, tbody, th, td, tr {
			display: block;
		}
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}
    tr {
      margin: 0 0 1rem 0;
    }
    tr:nth-child(odd) {
      background: #ccc;
    }
		td {
			border: none;
			border-bottom: 1px solid #eee;padding-left: 50%;
			position: relative;
		}
		td:before {
			position: absolute;
			top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap;
		}
		td:nth-of-type(1):before { content: "id"; }
		td:nth-of-type(2):before { content: "No"; }
		td:nth-of-type(3):before { content: "Tarih"; }
		td:nth-of-type(4):before { content: "S.Nedeni"; }
		td:nth-of-type(5):before { content: "S.Kod"; }
		td:nth-of-type(6):before { content: "S.Durumu"; }
		td:nth-of-type(7):before { content: "S.Tipi"; }
		td:nth-of-type(8):before { content: "Guide"; }
	}
@media screen and (min-width: 992px) and (max-width: 2000px) {
table, td, th {  
  /*border: 1px solid #ddd;*/
  text-align: left;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding:15px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/servis/devameden.vue